import React from 'react';
import { FormControlLabel, TextField } from '@material-ui/core'
import RemoveIcon from '@material-ui/icons/Remove';

const HorarioUtilizacao = ({name, item, handleInputTime}) => {
  const names = name.split('.');
  let bloco = [];
  if(item.label !== 'Nenhum')
    bloco.push(
      <FormControlLabel
        key={'formControl'}
        control={
          <>
            <TextField
              type="time"
              disabled={!item.isChecked}
              name={`${item.label}.${'inicio'}`}
              required={!item.isChecked ? false : true}
              defaultValue={item.Horarios.inicio}
              onChange={(event) => handleInputTime(event, names[0], names[1], item)}
              // color="primary"
              size="small"
              variant="outlined"
              margin="dense"
            />
            <RemoveIcon color="primary"></RemoveIcon>
            <TextField
              type="time"
              disabled={!item.isChecked}
              name={`${item.label}.${'fim'}`}
              defaultValue={item.Horarios.fim}
              required={!item.isChecked ? false : true}
              onChange={(event) => handleInputTime(event, names[0], names[1], item)}
              color="primary"
              size="small"
              variant="outlined"
              margin="dense"
            />
          </>
        }
      />
    )

      return bloco;
}

export default HorarioUtilizacao;
